module.exports = __webpack_public_path__ + "static/img/sdhxTu3@2x.719257c1.png";